import React, { PropsWithChildren } from 'react';

import { FeatureTileContainer } from './testimoninalTile.styled';

interface FeatureTileProps {
  image: string;
  alignment: 'left' | 'right';
}

export function TestimoninalTile({ image, alignment, children, color }: PropsWithChildren<FeatureTileProps>) {
  return (
    <FeatureTileContainer $color={color} $alignment={alignment}>
      {children}
    </FeatureTileContainer>
  );
}
